<template>
  <div class="receive-order-list">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>订单编号</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入订单编号" v-model="table.search.number"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>费项科目</p>
          </a-col>
          <a-col>
            <a-select class="app-block" v-model="table.search.fee" placeholder="请选择费项科目">
              <a-select-option :value="value.id" v-for="value in feeOptions" :key="value.id">{{value.name}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>订单状态</p>
          </a-col>
          <a-col>
            <a-select class="app-block" v-model="table.search.status" placeholder="请选择订单状态">
              <a-select-option :value="1">{{receiveOrderStatusText(1)}}</a-select-option>
              <a-select-option :value="2">{{receiveOrderStatusText(2)}}</a-select-option>
              <a-select-option :value="3">{{receiveOrderStatusText(3)}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
          <a-button @click="exportTable">导出</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="action" slot-scope="text, data">
        <a-space>
          <template v-if="data.order_status === 1">
            <a-button type="link" @click="orderSettingsOne(data)">催缴</a-button>
            <a-button type="link" @click="orderSettingsTwo(data)">设为已缴</a-button>
            <a-button type="link" @click="orderSettingsThree(data)">调价</a-button>
            <a-button type="link" @click="orderSettingsFour(data)">作废</a-button>
          </template>
        </a-space>
      </template>
    </a-table>
    <a-modal :title="modalOne.title" v-model="modalOne.show" @ok="confirmModalOne" destroy-on-close width="60%" centered>
      <receive-order-settings-one ref="receiveOrderSettingsOne" :id="modalOne.id"></receive-order-settings-one>
    </a-modal>
    <a-modal :title="modalTwo.title" v-model="modalTwo.show" @ok="confirmModalTwo" destroy-on-close width="60%" centered>
      <receive-order-settings-two ref="receiveOrderSettingsTwo" :id="modalTwo.id"></receive-order-settings-two>
    </a-modal>
    <a-modal :title="modalThree.title" v-model="modalThree.show" @ok="confirmModalThree" destroy-on-close width="60%" centered>
      <receive-order-settings-three ref="receiveOrderSettingsThree" :id="modalThree.id"></receive-order-settings-three>
    </a-modal>
  </div>
</template>

<script>
  import {
    receiveOrderStatusText
  } from '@/io/dict.js';
  import ExpendService from '@/io/expend.js';
  import ReceiveOrderSettingsOne from '@/views/community/receive_order/SettingsOne.vue';
  import ReceiveOrderSettingsTwo from '@/views/community/receive_order/SettingsTwo.vue';
  import ReceiveOrderSettingsThree from '@/views/community/receive_order/SettingsThree.vue';

  export default {
    name: 'ReceiveOrderList',
    props: {
      communityId: {
        type: Number,
        default: null
      },
      id: {
        type: Number,
        default: null
      },
      level: {
        type: Number,
        default: null
      }
    },
    data() {
      let self = this;
      return {
        receiveOrderStatusText,
        feeOptions: [],
        table: {
          loading: false,
          search: {
            number: null,
            fee: [],
            status: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '订单编号',
              dataIndex: 'no'
            },
            {
              title: '房间号',
              dataIndex: 'houses_tree_branch'
            },
            {
              title: '费项科目',
              dataIndex: 'charges_name'
            },
            {
              title: '账单开始日期',
              dataIndex: 'cycle_start_date'
            },
            {
              title: '账单结束日期',
              dataIndex: 'cycle_end_date'
            },
            {
              title: '账期',
              dataIndex: 'date'
            },
            {
              title: '应收金额',
              dataIndex: 'price'
            },
            {
              title: '已收金额',
              dataIndex: 'pay_price'
            },
            {
              title: '违约金',
              dataIndex: 'late_fee_price'
            },
            {
              title: '订单状态',
              dataIndex: 'receiveOrderStatusText'
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        modalOne: {
          id: null,
          title: '设为已缴',
          show: false
        },
        modalTwo: {
          id: null,
          title: '调价',
          show: false
        },
        modalThree: {
          id: null,
          title: '作废',
          show: false
        }
      }
    },
    components: {
      ReceiveOrderSettingsOne,
      ReceiveOrderSettingsTwo,
      ReceiveOrderSettingsThree,
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          if ((newValue || oldValue) && !this.table.loading) {
            this.searchTable();
          }
        },
        immediate: true
      },
      communityId: {
        handler(newValue, oldValue) {
          if ((newValue || oldValue) && !this.table.loading) {
            this.initFeeOptions().then(() => {
              this.searchTable();
            });
          }
        },
        immediate: true
      }
    },
    methods: {
      orderSettingsOne(data) {
        ExpendService.orderSettingsOne([data.id]).then(() => {
          this.$message.success('操作成功');
        }).catch(err => {});
      },
      orderSettingsTwo(data) {
        this.modalOne.id = data.id;
        this.modalOne.show = true;
      },
      confirmModalOne() {
        this.$refs.receiveOrderSettingsOne.submit(() => {
          this.initData();
          this.modalOne.show = false;
        });
      },
      orderSettingsThree(data) {
        this.modalTwo.id = data.id;
        this.modalTwo.show = true;
      },
      confirmModalTwo() {
        this.$refs.receiveOrderSettingsTwo.submit(() => {
          this.initData();
          this.modalTwo.show = false;
        });
      },
      orderSettingsFour(data) {
        this.modalThree.id = data.id;
        this.modalThree.show = true;
      },
      confirmModalThree() {
        this.$refs.receiveOrderSettingsThree.submit(() => {
          this.initData();
          this.modalThree.show = false;
        });
      },
      initFeeOptions() {
        return ExpendService.list([this.communityId]).then(res => {
          this.feeOptions = res;
        }).catch(err => {});
      },
      expendSettings() {
        this.modal.show = true;
      },
      handleSubmit() {
        this.modal.show = false;
      },
      scanExpendSettings(data) {
        this.$router.push({
          name: 'ExpendSettingsDetail',
          params: {
            id: data.id
          }
        });
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          number: null,
          fee: [],
          status: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        this.$emit('total', 0);
        ExpendService.orderListPage(
          this.table.search.number,
          this.table.search.fee,
          this.table.search.status,
          this.communityId,
          this.level === 1 ? this.id : null,
          this.level === 2 ? this.id : null,
          this.level === 3 ? this.id : null,
          this.level === 4 ? this.id : null,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.receiveOrderStatusText = receiveOrderStatusText(val.order_status);
            val.date = val.billing_cycle_type === 1 ? `${val.billing_year}-${val.billing_month}` : (val.billing_cycle_type === 2 ? `${val.billing_year}-${this.quarter(val.billing_month)}` : (val.billing_cycle_type === 3 ? val.billing_year : val.billing_date))
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
          this.$emit('total', res.meta.pagination.total);
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
      quarter(month) {
        let quarter = {
          1: 'Q1',
          2: 'Q1',
          3: 'Q1',
          4: 'Q2',
          5: 'Q2',
          6: 'Q2',
          7: 'Q3',
          8: 'Q3',
          9: 'Q3',
          10: 'Q4',
          11: 'Q4',
          12: 'Q4',
        }
        return quarter[month];
      },
      exportTable() {
        ExpendService.exportList(
          this.table.search.number,
          this.table.search.fee,
          this.table.search.status,
          this.communityId,
          this.level === 1 ? this.id : null,
          this.level === 2 ? this.id : null,
          this.level === 3 ? this.id : null,
          this.level === 4 ? this.id : null
        )
      }
    },
  }
</script>

<style lang="less" scoped>

</style>